import KPageHeader from 'common/component/KPageHeader';
import KProTip from 'common/component/KProTip';
import { tableCustomStyles } from 'common/style/tableCustomStyle';
import React, { useMemo } from 'react';
import DataTable from 'react-data-table-component';
import styled from 'styled-components';
import { Drawer } from 'antd';
import AddSubjectDetails from './AddSubjectDetails';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { useSubject } from 'features/result/hooks/useSubject';

interface Props {}

const SubjectView: React.FC<Props> = () => {
  const [visible, setVisible] = React.useState(false);
  const subjects = useSelector((state: RootState) => state.subject);
  const [reloadSubject, setReloadSubject] = React.useState(true);
  const { fetchSubject } = useSubject();

  const TableColumn = () => [
    {
      name: 'Subject',
      selector: 'title',
      sortable: true,
    },
    {
      name: 'Code',
      selector: 'code',
      sortable: true,
    },
    {
      name: 'Grade',
      selector: 'gradeId',
      sortable: true,
    },
    {
      name: 'Full Mark',
      selector: 'full_mark',
      sortable: true,
    },
    {
      name: 'Pass Mark',
      selector: 'pass_mark',
      sortable: true,
    },
  ];

  const showDrawer = () => {
    setVisible(true);
  };
  const onClose = () => {
    setVisible(false);
  };

  const memoSubjectReload = useMemo(() => reloadSubject, [reloadSubject]);

  React.useEffect(() => {
    if (memoSubjectReload) {
      fetchSubject();
      setReloadSubject(false);
    }
  }, [memoSubjectReload]);

  return (
    <SubjectViewWrapper>
      <KPageHeader title="Subject" rightButtonTitle="Add Subject" onRightButtonClick={showDrawer} />
      <Drawer
        width={705}
        title={<h2 style={{ fontWeight: 700 }}>Add Subject</h2>}
        placement="right"
        onClose={onClose}
        visible={visible}
        closable={false}
      >
        {<AddSubjectDetails onVisibleChange={setVisible} onSetReloadSubject={setReloadSubject} />}
      </Drawer>
      <KProTip
        title="Page Hint"
        description="This page is for viewing and managing all the subjects that are currently in this system"
      />
      <section className="dataTable">
        <DataTable
          customStyles={tableCustomStyles}
          className="data-table"
          noHeader
          highlightOnHover
          pagination
          responsive={true}
          data={subjects.data}
          columns={TableColumn()}
        />
      </section>
    </SubjectViewWrapper>
  );
};

export const SubjectViewWrapper = styled.div`
  padding-right: 20px;
  .dataTable {
    margin-top: 20px;
  }
`;

// const SubjectView = () => <h1>Hellop</h1>;

export default SubjectView;
